module.exports = __webpack_public_path__ + "img/f237fc7.jpg";